import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["viewer", "editor"];

  connect() {
    // Hide editor by default
    this.editorTarget.classList.add("hidden");
    this.viewerTarget.classList.remove("hidden");
  }

  showEditor(event) {
    event.preventDefault();
    this.viewerTarget.classList.add("hidden");
    this.editorTarget.classList.remove("hidden");
  }

  hideEditor(event) {
    event.preventDefault();
    this.editorTarget.classList.add("hidden");
    this.viewerTarget.classList.remove("hidden");
  }
}
